import { CapaServiceType } from '@generated/graphql';
import jwtDecode from '@utils/jwtDecode';

const getScopes = () => {
  const jwt = jwtDecode();

  const typeConvertedScopes = new Set(jwt?.scopes);

  typeConvertedScopes.delete(CapaServiceType.Cloud);

  if (
    typeConvertedScopes.has(CapaServiceType.Quotation) &&
    typeConvertedScopes.has(CapaServiceType.QuotationPartner) &&
    typeConvertedScopes.has(CapaServiceType.Connect)
  ) {
    return {
      email: jwt?.aud as string,
      scopes: [
        CapaServiceType.Quotation,
        CapaServiceType.QuotationPartner,
        CapaServiceType.Connect
      ]
    };
  }

  if (
    typeConvertedScopes.has(CapaServiceType.Quotation) &&
    typeConvertedScopes.has(CapaServiceType.QuotationPartner) &&
    !typeConvertedScopes.has(CapaServiceType.Connect)
  ) {
    return {
      email: jwt?.aud as string,
      scopes: [CapaServiceType.Quotation, CapaServiceType.QuotationPartner]
    };
  }

  if (
    typeConvertedScopes.has(CapaServiceType.Quotation) &&
    !typeConvertedScopes.has(CapaServiceType.QuotationPartner) &&
    typeConvertedScopes.has(CapaServiceType.Connect)
  ) {
    return {
      email: jwt?.aud as string,
      scopes: [CapaServiceType.Quotation, CapaServiceType.Connect]
    };
  }

  if (
    !typeConvertedScopes.has(CapaServiceType.Quotation) &&
    typeConvertedScopes.has(CapaServiceType.QuotationPartner) &&
    typeConvertedScopes.has(CapaServiceType.Connect)
  ) {
    return {
      email: jwt?.aud as string,
      scopes: [CapaServiceType.QuotationPartner, CapaServiceType.Connect]
    };
  }

  return {
    email: jwt?.aud as string,
    scopes: Array.from(typeConvertedScopes)
  };
};

export default getScopes;
